module.exports = __webpack_public_path__ + "static/media/transunion.ea372fa6.png";